export default "__VITE_ASSET__D1osfm9F__"